import React from 'react';
import Tool from '../Tool/Tool';
import { Button } from '../Button/Button';

import slack from '../../images/slack-icon.svg';
import gmail from '../../images/gmail.svg';
import asana from '../../images/asana-logo.svg';
import linear from '../../images/linear-logo.svg';
import jira from '../../images/jira.svg';
import apple from '../../images/apple-reminders.svg';
import scribble from '../../images/scribble.svg';
import './Tools.scss';

const Tools = () => (
  <div className="tools">
    <div className="relative container">
      <h1 className="heading">
        Connect with your <span className="text-gradient">favorite tools</span>
      </h1>
      <p className="sub-heading">
        Status updates and task integrations with tools you love and use
      </p>

      <div className="grid">
        <Tool
          name="Slack"
          description="Auto-snooze Slack and update status based on calendar. Create task right within Slack."
          image={slack}
        />
        <Tool
          name="Asana"
          description="Convert any email into a task and schedule to reply on time."
          image={asana}
        />
        <Tool
          name="Jira"
          comingSoon
          description="Convert Asana tickets to Aerotime tasks. Schedule them with ease."
          image={jira}
        />
        <Tool
          name="Gmail"
          description="Convert issues into tasks in Aerotime. Schedule them with ease and keep team in alignment."
          image={gmail}
        />
        <Tool
          name="Linear"
          description="Link customer feedback to issues, and keep your development team in the loop"
          image={linear}
          comingSoon
        />
        <Tool
          name="Reminders"
          description="Convert Apple Reminders to Aerotime tasks."
          image={apple}
          comingSoon
        />
      </div>
      <div className="wrap-btn">
        <Button size="lg" text="Explore Integrations" type="primary" />
      </div>
      <img className="scribble" src={scribble} alt="" />
    </div>
  </div>
);

export default Tools;
